<template>
  <div v-if="props.styling === 'generic' && props.progress" class="progress-bar-generic">
    <label v-if="showLabel && props.progress.message">
      <span :class="{ 'font-weight-bold': props.progress.state !== ProgressState.Finished }">{{ props.progress.message }}</span>
    </label>
    <spinner-bar :animation-on="showProgressBar" v-if="props.progress.isIndeterminate" v-show="showProgressBar" class="mb-3" :size="props.size" />
    <b-progress
      class="my-1 progress-bar-determinate"
      :class="progressBarClasses"
      v-if="!props.progress.isIndeterminate"
      v-show="showProgressBar"
      :max="props.progress.max">
      <b-progress-bar :value="props.progress.value"> </b-progress-bar>
    </b-progress>
    <Alert show variant="danger" v-if="hasError">
      <span>{{ props.progress.errorMessage }}</span>
    </Alert>
  </div>

  <div v-else class="progress-bar-area">
    <div v-if="showLabel" class="progress-step-info">
      {{ props.progress.message }}
    </div>
    <div class="progress-container" :class="progressBarClasses">
      <div class="progress-bar-animated"></div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ProgressState } from "@medapro-types/common/components/ProgressHandling";
import { ProgressData } from "@medapro-types/common/components/ProgressModal";
import { computed } from "vue";
import Alert from "./Alert.vue";
import SpinnerBar from "./SpinnerBar.vue";

const props = withDefaults(
  defineProps<{
    styling?: "generic" | "simple";
    size: "sm" | "md";
    progress: ProgressData;
    alwaysShow?: boolean;
  }>(),
  {
    size: "sm",
    styling: "generic",
    alwaysShow: false
  }
);

const showProgressBar = computed(() => {
  return props.progress?.state === ProgressState.Ongoing || props.alwaysShow;
});

const hasError = computed(() => {
  return props.progress?.state === ProgressState.Error;
});

const showLabel = computed(() => {
  return props.progress.withLabel ?? false;
});

const progressBarClasses = computed(() => {
  return [props.size];
});
</script>
